import { MODAL_SEARCH_PARAM } from 'src/routes/utils/modal-routes';

import { Capacitor } from '@capacitor/core';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

type Props = {
  children: React.ReactNode;
};

export const RouterWithScrollToTop = ({ children }: Props) => {
  const location = useLocation();
  const prevPathname = useRef(location.pathname);
  const prevModal = useRef(
    new URLSearchParams(location.search).get(MODAL_SEARCH_PARAM),
  );

  useEffect(() => {
    const modal = new URLSearchParams(location.search).get(MODAL_SEARCH_PARAM);
    const isModalNavigation =
      location.pathname === prevPathname.current && modal !== prevModal.current;

    if (location.pathname !== prevPathname.current && !isModalNavigation) {
      const isNativePlatform = Capacitor.isNativePlatform();

      if (isNativePlatform) {
        requestAnimationFrame(() => {
          window.scrollTo(0, 0);
        });
      } else {
        window.scrollTo(0, 0);
      }
    }

    prevPathname.current = location.pathname;
    prevModal.current = modal;
  }, [location.pathname, location.search]);

  return <>{children}</>;
};
